import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import './style.scss';
import { onEnterOrSpace } from '../../../components/utils/util-functions';
import Cookies from '../../../cookies';

class FacebookSSOComponent extends React.Component {
  constructor(props) {
    super(props);
    this.path = `${this.props.location.pathname}`;
    this.signUp = this.props.mode === 'signup' ? '?signup=true' : '';
    Cookies.set('product_id', window.product_id);
  }

  login() {
    if (this.props.onClick) {
      this.props.onClick();
    }
    let next = encodeURIComponent(`${this.path}${this.signUp}`);
    try {
      // eslint-disable-next-line max-len
      window.location.href = window['OAUTH_URLS']['facebook'].concat(
        `?next=${this.path}${this.signUp}&product_id=${window.product_id}`
      );
    } catch (ignore) {
      // Running on local dev
      window.location.href = `http://localhost:8000/login/facebook/?next=${next}&product_id=${window.product_id}`;
    }
  }
  render() {
    return (
      <a
        tabIndex={0}
        id="sl-facebook-sso"
        onClick={this.login.bind(this)}
        onKeyDown={e => onEnterOrSpace(e, this.login.bind(this))}
      >
        <span>{this.props.mode === 'signup' ? 'Sign up' : 'Login'}</span>
        <span> with Facebook</span>
      </a>
    );
  }
}

FacebookSSOComponent.propTypes = {
  match: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  location: PropTypes.object.isRequired,
  mode: PropTypes.string.isRequired,
};

export default withRouter(FacebookSSOComponent);
